import React from 'react';
import { NavLink } from 'react-router-dom';

const HowitWorks = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">How it Works?</h1>
      
      <p>
        XLR8 is powered by Stripe, ensuring that your data and credit card information are securely encrypted. 
        Stripe does not share any of your credentials, providing peace of mind during your transactions.
      </p>

      <p>
        We don’t charge sellers a single cent.
      </p>

      <p>
        Buyers are only charged once we have received confirmation that the transaction has successfully concluded.
      </p>

      <p>
        For the purchase and <NavLink to="/faq/ownership-transfer" className="text-decoration-none">ownership transfer process</NavLink>, XLR8 does not handle any procedures. You can rest assured that we do not manage any payment between the buyer and the seller. Our role is simply to charge a commission on transacted vehicles.
      </p>

      <p>
        If you have any questions or concerns regarding payment, feel free to contact us at <strong>admin@xlr8.sg</strong>.
      </p>
    </div>
  );
};

export default HowitWorks;
